import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingPanelService {

  private _showSource = new Subject<boolean>();
  showSource$ = this._showSource.asObservable();

  private _hideSource = new Subject<any>();  
  hideSource$ = this._hideSource.asObservable();

  show(showSimple: boolean = false) {
    this._showSource.next(showSimple);
  }

  hide(obj ?: any){
    this._hideSource.next(obj);
  }
}
